// The /demand page filters its file list on `search` and auto-opens the View
// Config modal for `viewConfig` (see DemandData.tsx), so a link that sets both
// lands the operator on the file's config rather than just a filtered list.
export const demandFileUrl = (guid: string, openConfig = false) => {
  const encoded = encodeURIComponent(guid);
  return `/demand?search=${encoded}${openConfig ? `&viewConfig=${encoded}` : ""}`;
};
